<template>
  <div>
    <!-- 개인정보 수집 및 이용에 대한 동의 -->
    <div class="title mt12">개인정보 수집 및 이용에 대한 동의</div>
    <div class="content mt20">
      <div class="common">
        <div class="sub-title bold">[개인정보 수집 및 이용 동의]</div>
        <div class="detail">
          회원님은 한국디지털거래소(이하 회사)에서 제공하는 입금 및 거래 서비스
          이용을 위한 신원 인증에 필요한 최소한의 개인 정보 수집 및 이용에
          동의를 거부하실 수 있으며, 거부 시에는 입금 및 거래 서비스 이용이 불가
          합니다.
        </div>
        <div class="sub-title bold">[개인정보 이용 목적 및 수집 항목]</div>
        <div class="detail">
          특정 금융거래정보의 보고 및 이용 등에 관한 법률 및 동법시행령에 따른
          신원 인증(비대면 실명확인 및 고객확인제도 )업무
        </div>
      </div>

      <!-- 신원인증(내국인) -->
      <div class="middle-box">신원인증(내국인)</div>
      <div class="list">
        <div class="common">
          <div class="sub-title">
            <span class="keycolor">[필수]</span> STEP.1 신원인증 기초 정보
          </div>
          <div class="detail">내국인/외국인 여부, 국적, 거주/비거주 여부</div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> STEP.2 휴대폰 본인 인증
          </div>
          <div class="detail">
            이름, 생년월일, 성별, 내국인/외국인 정보, 휴대전화번호, 동일인
            식별정보(CI), 중복가입확인정보(DI)
          </div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.2 신분증 인증
          </div>
          <div class="detail">
            (주민등록증)이름, 주민등록번호, 발급일자, 신분증 사진
          </div>
          <div class="detail">
            (운전면허증)이름, 주민등록번호, 운전면허번호, 암호일련번호,
            발급일자, 신분증 사진
          </div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.3 신원 인증
          </div>
          <div class="detail">
            영문 이름 주소, 거래목적, 자금출처, 실제 소유자 여부, 직업<br />*고위험
            직군인 경우 추가 항목
          </div>
          <div class="detail">
            개인<br /><span class="keycolor">[필수]</span> 직장명, 직장 연락처,
            직장 주소<br />[선택] 부서명, 직위
          </div>
          <div class="detail">
            개인사업자<br /><span class="keycolor">[필수]</span> 업체명, 사업자
            등록번호, 업종, 사업장 주소, 연락처<br />[선택] 설립일자
          </div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.4 본인인증 소액계좌이체
          </div>
          <div class="detail">금융기관명, 계좌번호, 예금주명</div>
        </div>
      </div>

      <!-- 신원인증(거주 외국인) -->
      <div class="middle-box">신원인증(거주 외국인)</div>
      <div class="list">
        <div class="common">
          <div class="sub-title">
            <span class="keycolor">[필수]</span> STEP.1 신원인증 기초 정보
          </div>
          <div class="detail">내국인/외국인 여부, 국적, 거주/비거주 여부</div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.2 휴대폰 본인 인증
          </div>
          <div class="detail">
            이름, 생년월일, 성별, 내국인/외국인 구분, 휴대전화번호, 동일인
            식별정보(CI), 중복가입확인정보(DI)
          </div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.3 고객정보 확인
          </div>
          <div class="detail">
            외국인등록번호, 외국인 등록증 발급일자, 외국인 등록증 만료일자,
            주소, 거래목적, 자금출처, 실제 소유자여부, 직업<br />*고위험 직군인
            경우 추가 항목
          </div>
          <div class="detail">
            개인<br /><span class="keycolor">[필수]</span> 직장명, 직장 연락처,
            직장 주소<br />[선택] 부서명, 직위
          </div>
          <div class="detail">
            개인사업자<br /><span class="keycolor">[필수]</span> 업체명, 사업자
            등록번호, 업종, 사업장 주소, 연락처<br />[선택] 설립일자
          </div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.4 신분증 증명(제출)
          </div>
          <div class="detail">
            외국인 등록증 앞면, 뒷면 사본, 성명, 외국인등록번호, 국적, 이름,
            성별, 발급일자, 만료일자
          </div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.5 영상통화
          </div>
          <div class="detail">영상통화 동영상 파일</div>
        </div>
      </div>

      <!-- 신원인증(비거주 외국인) -->
      <div class="middle-box">신원인증(비거주 외국인)</div>
      <div class="list">
        <div class="common">
          <div class="sub-title">
            <span class="keycolor">[필수]</span> STEP.1 신원인증 기초 정보
          </div>
          <div class="detail">내국인/외국인 여부, 국적, 거주/비거주 여부</div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.2 휴대폰 점유 인증
          </div>
          <div class="detail">이름, 통신사 국가, 휴대폰 번호</div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.3 고객정보 확인
          </div>
          <div class="detail">
            여권번호, 생년월일, 성별, , 주소, 거래목적, 자금출처, 실제 소유자
            여부, 직업<br />*고위험 직군인 경우 추가 항목
          </div>
          <div class="detail">
            개인<br /><span class="keycolor">[필수]</span> 직장명, 직장 연락처,
            직장 주소<br />[선택] 부서명, 직위
          </div>
          <div class="detail">
            개인사업자<br /><span class="keycolor">[필수]</span> 업체명, 사업자
            등록번호, 업종, 사업장 주소, 연락처<br />[선택] 설립일자
          </div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.4 신분증 증명(제출)
          </div>
          <div class="detail">
            여권 사본, 추가 신분증 사본<br />[택1: 자국 신분증, 자국 운전면허증,
            국제 운전 면허증], 국적, 이름, 여권번호, 생년월일, 성별
          </div>
          <div class="detail">
            거주지 증명서류 사본(택1)<br />
            - 공과금 고지서(전기, 수도, 가스요금, 관리비영수증)<br />- 고객명,
            주소가 표시된 최근 3개월내 고지서, 본국 관공서에서 발급한 주소증명서
            또는 거주 사실 증명서, 본국 공증인이 주소를 공증한 문서<br />-
            거주지 국가, 거주지 주소, 이름
          </div>
          <div class="sub-title">
            <span class="keycolor">[필수]</span> Step.5 영상통화
          </div>
          <div class="detail">영상통화 동영상 파일</div>
        </div>
      </div>
    </div>
    <!-- //개인정보 수집 및 이용에 대한 동의 -->

    <!-- 개인정보 보유 및 이용 기간 -->
    <div class="title pt27 top-line">개인정보의 보유 및 이용 기간</div>
    <div class="content duration">
      <div class="list">
        <div class="common MT20">
          개인정보의 수집 항목: 회원탈퇴 시까지 다만, 법령상 의무이행을 위한
          경우 법령에서 정한 기간까지 별도 보관.
          <div class="sub-title">[개인정보 처리 위탁]</div>
          <div class="detail bold">수탁사 및 위탁하는 업무의 내용</div>
          <div class="sub-title">세틀뱅크㈜</div>
          <div class="detail">입출금 서비스, 예금주 실명 확인</div>
          <div class="sub-title">영상통화 업체</div>
          <div class="detail">영상통화 정보</div>
          <div class="sub-title">NICE평가정보㈜</div>
          <div class="detail">휴대폰 인증 정보 확인</div>
          <div class="sub-title">㈜코인플러그</div>
          <div class="detail">
            휴대폰 본인인증 정보 확인 및 신분증 진위여부 확인
          </div>
          <div class="sub-title bold">보유 및 이용 기간</div>
          <div class="detail">회원탈퇴 시 또는 위탁계약 종료 시 까지</div>
        </div>
      </div>
    </div>
    <!-- //개인정보 보유 및 이용 기간 -->

    <button @click="toStep1" class="next-button mt8">동의</button>
  </div>
</template>
<script>
export default {
  methods: {
    toStep1() {
      this.$emit("toStep1");
    },
  },
};
</script>
<style lang="scss" scoped>
.bold {
  font-weight: bold;
}
.keycolor {
  color: #eb3246;
}
.title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  &.top-line {
    border-top: 1px solid #dcdfe3;
  }
}
.content {
  .common {
    margin-bottom: 24px;
    .sub-title {
      margin-top: 20px;
    }
    .detail {
      margin-top: 8px;
    }
  }
  .list {
    .detail {
      position: relative;
      padding-left: 12px;
      &:before {
        content: "";
        position: absolute;
        top: 7px;
        left: 0;
        width: 4px;
        height: 4px;
        border-radius: 10px;
        background-color: #333;
      }
    }
  }
  &.duration {
    .common {
      .sub-title {
        margin-top: 12px;
      }
      .detail {
        margin-top: 4px;
      }
    }
  }
}

.middle-box {
  padding: 8px 0;
  text-align: center;
  background-color: #f7f8fa;
}
// 하단 다음 버튼
button.next-button {
  width: 100%;
  padding: 10px 0;
  background-color: #00b473;
  &.bottom {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 24px);
  }
}
</style>
